const sensitiveWord = () => import ('./views/sensitiveWord.vue');

export default {
  //敏感词
  path: "/sensitiveWord",
  name: "sensitiveWord",
  component: sensitiveWord,
  meta: {
    title: "敏感词管理",
    root: "/appCenter"
  }
}



// WEBPACK FOOTER //
// ./src/core/modules/sensitiveWord/router.js